(function () {
  function initFaq(section) {
    if (section.dataset.faqInit === 'true') return;
    section.dataset.faqInit = 'true';

    var items = section.querySelectorAll('.basiq-faq-item');

    items.forEach(function (item) {
      var trigger = item.querySelector('.basiq-faq-item__trigger');
      if (!trigger) return;

      trigger.addEventListener('click', function () {
        var isOpen = item.classList.contains('is-open');

        items.forEach(function (other) {
          other.classList.remove('is-open');
        });

        if (!isOpen) {
          item.classList.add('is-open');
        }
      });
    });
  }

  function initAll() {
    document.querySelectorAll('.basiq-faq').forEach(initFaq);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }

  document.addEventListener('shopify:section:load', initAll);
})();